import { DropdownDownFill18Icon } from "@vygruppen/spor-icon-react";
import styled from "styled-components";

export const ArrowIcon = styled(DropdownDownFill18Icon)<{ rotate?: number }>`
  rotate: ${({ rotate }) => (rotate ? `${rotate}deg` : "0deg")};
  transition: rotate 0.3s ease;
`;
